module.exports = __webpack_public_path__ + "fonts/5b057a2.otf";